/*********************
	构造函数:
		var browseDomElement = 'dom1';					//绑定页面的某个DOM元素为选择文件按钮（必填参数）
		var dropDomElement = 'dom2';					//绑定页面的某个DOM元素为拖拽文件区域（可选参数）
		var filterFileTypes = 'jpg,jpeg,png'			//允许上传的文件类型（可选参数）
		var upload = new kabalaupload(browseDomElement, dropDomElement, filterFileTypes)
	方法函数:
		var fileids = upload.listFileIds();				//列出所有待上传文件ID数组
		var file = upload.getFile(fileids[0]);			//获取待上传文件对象, 该对象具有属性 [id/name/path/size/loaded-已处理字节数/md5-文件MD5/chunksize-分片尺寸/chunkmd5s-分片MD5s/chunkadler32s-分片ADLER32s]
		upload.triggleFileHash(file, chunksize);		//发起动作--计算文件哈希 (如果chunksize<=0则表示只计算文件整体MD5而不计算分片MD5s及分片ADLER32s)
		upload.triggleFileUpload(file, chunksize, maxretries);
														//发起动作--上传文件(以指定分片大小chunksize进行多次分片上传, 如果chunksize<=0则表示分片大小为无穷大, 如果分片传输失败则重试 maxretries 次, 为0表示不做重试)
		upload.setUploadParams(httpurl, httpmethod, httpheaders, ispostmultiform, postmultiforms)
														//设置上传传输参数 (在传输数据时，会以最后一次设置的参数为准)
		upload.setChunkSkip(file, chunkoffset);			//设置跳过分片传输 (针对被跳过的分片, 传输时会跳过不做传输)
		upload.cancelFileUpload(file);					//触发动作--停止该文件的上传
		upload.removeFile(fileids[0]);					//把文件移出上传列表
		var isuploading = upload.isUploading();			//判断是否正在上传中
		var fileid1 = upload.getUploadingFile();		//获取正在上传中的文件
		var ishashing = upload.isHashing();				//判断是否正在计算文件哈希
		var fileid2 = upload.getHashingFile();			//获取正在计算哈希中的文件
	事件处理：
		upload.bindFileAdded(function(files){});		//事件--当有新文件加入后触发
		upload.bindFileHashed(function(file){});		//事件--当文件md5计算完毕后触发 (triggleFileHash 计算完毕后, 不论是否成功, 均触发该事件)
		upload.bindFileUploadBegin(function(file){});	//事件--当准备要上传该文件时触发 (triggleFileUpload 开始后)
		upload.bindFileUploadSuccess(function(file){});	//事件--当上传文件传输成功后触发 (triggleFileUpload 成功结束后)
		upload.bindFileUploadError(function(file){});	//事件--当上传文件传输失败后触发 (triggleFileUpload 异常终止后)
		upload.bindFileUploadCancel(function(file){});	//事件--当上传文件传输被取消后触发 (cancelFileUpload 后)
		upload.bindChunkUploadBegin(function(file, chunkOffset){});		//事件--当上传文件分片传输开始后触发 (任意文件传输均会触发该分片传输事件)
		upload.bindChunkUploadSuccess(function(file, chunkOffset){});	//事件--当上传文件分片传输成功后触发
		upload.bindFileUploadProgress(function(file, loaded){});		//事件--当上传文件进度刷新后触发
	注意事项：
		同一时间最多只有一个文件一个分片在进行数据传输，不支持多文件或多分片并发上传，仅支持串行上传。
**********************/


/********** 动态加载所需的JS *******************/
// function getjspath(jsfilename){
// 	var sc = document.getElementsByTagName("script");
// 	for(idx = 0; idx < sc.length; idx++)
// 	{
// 	  s = sc.item(idx);
// 	  if(s.src && s.src.length>=jsfilename.length){
// 		  // 编译打包时可能会加上日期号, v=xxxxxxx
// 			var sbfilename = s.src.substring(s.src.length-jsfilename.length);
// 			if( sbfilename.indexOf('?') > -1 ){
// 				sbfilename = sbfilename.substring(0, sbfilename.indexOf('?'))
// 			}
// 			var jsfilename1 = jsfilename;
// 			if( jsfilename1.indexOf('?') > -1 ){
// 				jsfilename1 = jsfilename1.substring(0, jsfilename1.indexOf('?'))
// 			}
// 		  if(sbfilename == jsfilename1){
// 			  var parenturl = s.src.substring(0, s.src.length-jsfilename.length-1);
// 			  var s1 = parenturl.substring(parenturl.indexOf("//")+2);
// 			  var parenturi = s1.substring(s1.indexOf("/"));
// 			  return parenturi;
// 		  }
// 	  }
// 	}
// 	return '';
// }
// var KFSJSNAME = "kabalauploadjs";
// var KFSJSROOT = getjspath(KFSJSNAME);
// console.log('KFSJSROOT=>',KFSJSROOT)
// document.write("<script src='"+KFSJSROOT+"/goog.math.long.js'></script>")
// document.write("<script src='"+KFSJSROOT+"/spark-md5.js'></script>")
// document.write("<script src='"+KFSJSROOT+"/moxie.js'></script>")
// document.write("<script src='"+KFSJSROOT+"/plupload.kver.js'></script>")
// document.write("<script src='./moxie.js'></script>")
// const moxie = require('./moxie')
const goog = require('./goog.math.long')
const SparkMD5 = require('./spark-md5')
const plupload = require('./plupload.kver');


/*********************  封装 kabalaupload   *********************/
var kabalaupload = function(browseDomElement, dropDomElement, filterFileTypes,multi_selection) {
	//kabalaupload对象:
	var kfsup = this;
	kfsup.id = new Date().getTime( );
	kfsup.uploading = '';
	kfsup.hashing = '';

	//plupload对象:
	var plup = new plupload.Uploader({});

	plup.id = kfsup.id;
	plup.setOption('browse_button', browseDomElement);
	if(multi_selection!==undefined){
		plup.setOption('multi_selection',multi_selection);
	}
	if(dropDomElement && dropDomElement.length>0){
		plup.setOption('drop_element', dropDomElement);
	}

	if(filterFileTypes && filterFileTypes.length>0){

		console.log(filterFileTypes)
		// debugger

		plup.setOption('filters', {mime_types : [{ title : filterFileTypes, extensions : filterFileTypes}]} );
		// plup.setOption('filters', {mime_types : [{ title : "图片", extensions : 'jpg,jpeg,png'}]} );
		console.log('===')
	}


	// console.log('======')
		// console.log(plup.getOption())
	plup.init();
	plup.bind('FilesAdded',function(plup, files){
		//对于空文件，可能 file.size为undefined，我们要刷新一下
		for(var i=0;i<files.length;i++){
			var f = files[i];
			if(typeof(f.size)=='undefined'){
				f.size = f.getNative().size;
			}
		}

		//为每个文件添加一个属性 order 顺序编号
		var addfiles = new Array();
		var maxorder = 0;
		for(var index in plup.files){
			var file = plup.files[index];
			if(typeof(file.order)=='undefined'){
			}else{
				if(maxorder<file.order)
					maxorder = file.order;
			}
		}
		var order = maxorder;
		for(var i=0;i<files.length;i++){
			var file = files[i];
			if(typeof(file.order)=='undefined'){
				file.order = ++order;
				file.md5 = '';
				file.chunkmd5s = null;
				file.chunkadler32s = null;
				file.chunksize = 0;
				addfiles.push(file);
			}
		}
		if(addfiles.length>0 && kfsup.onFileAdded){
			kfsup.onFileAdded(addfiles);
		}
	});
	plup.bind('BeforeUpload', function(uploader, file){
		if(kfsup.onFileUploadBegin){
			kfsup.onFileUploadBegin(file);
		}
		return kfsup.uploading.length>0;
	});
	plup.bind('BeforeChunkUpload', function(uploader, file, postparams, currentBlob, currentOffset){
		if(kfsup.onChunkUploadBegin){
			kfsup.onChunkUploadBegin(file, currentOffset);
		}

		if(file.chunkskip){
			for(var i=0; i<file.chunkskip.length; i++){
				if(file.chunkskip[i]==currentOffset){
					//该分片需要跳过传输...
					return false;
				}
			}
		}
		return kfsup.uploading.length>0;
	});
	plup.bind('ChunkUploaded', function(uploader, file, result){
		if(kfsup.onChunkUploadSuccess){
			kfsup.onChunkUploadSuccess(file, result.offset);
		}
	});
	plup.bind('FileUploaded',function(uploader, file){
		kfsup.uploading = '';
		plup.stop();	//强行停止传输其他文件...(一次只传输队列中的一个文件，如果需要继续上传，请在外部调用 triggleFileUpload(file) )
		if(kfsup.onFileUploadSuccess){
			kfsup.onFileUploadSuccess(file);
		}
	});
	plup.bind('Error',function(uploader, errObject){
		kfsup.uploading = '';
		plup.stop();
		if(kfsup.onFileUploadError){
			kfsup.onFileUploadError(errObject); //errObject.code / errObject.file /errObject.message
		}
	});
	plup.bind('UploadProgress',function(uploader, file){
		if(kfsup.onFileUploadProgress){
			kfsup.onFileUploadProgress(file, file.loaded);
		}
	});

	//函数--计算文件校验码(文件md5-必定计算/分片md5-当chunkSize>0时计算/分片adler32-当chunkSize>0 且 chunkAdler32sFlag=true时计算)
	//file--文件对象（HTML5）
	//chunkSize--分片大小(取值一般为1M-16M, 表示用于计算分片 md5/adler32 的切片大小, -1或0表示不计算分片校验码)
	//chunkAdler32sFlag--是否计算每个分片的adler32？
	//callbackFn(file, md5, chunkmd5s[], chunkadler32s[], chunkSize)--回调函数
	var readFileMd5Adler32s = function(file, chunkSize, chunkMd5Flag, chunkAdler32sFlag, callbackFn) {
		if(chunkSize<=0){
			chunkSize = 1024*1024;
			chunkAdler32sFlag = false;
			chunkMd5Flag = false;
		}
		var fileobject = file.getNative === undefined ? file : file.getNative();

		var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
			chunks = Math.ceil(fileobject.size / chunkSize),
			currentChunk = 0,
			sparktotal = new SparkMD5.ArrayBuffer(),
			sparkchunk = new SparkMD5.ArrayBuffer(),
			fileReader = new FileReader();

		var chunkmd5s = new Array();
		var chunkadler32s = new Array();
		fileReader.onload = function (e) {
			sparktotal.append(e.target.result);
			if(chunkMd5Flag){
				sparkchunk.append(e.target.result);
				chunkmd5s.push( sparkchunk.end() );
			}
			if(chunkAdler32sFlag){
				var filebuf = new Uint8Array(e.target.result);

				//adler32 算法 (用于差异上传)
				//依赖文件 goog.math.long.js
				var adler32 = function(filebuf) {
					var a = 1, b = 0, L = filebuf.length, M = 0;
					for(var i = 0; i < L;) {
						M = Math.min(L-i, 3850)+i;
						for(;i<M;i++) {
							a += filebuf[i]&0xFF;
							b += a;
						}
						a = (15*(a>>>16)+(a&65535));
						b = (15*(b>>>16)+(b&65535));
					}
					a %= 65521;
					b %= 65521;
					return new goog.math.Long(b, 0).shiftLeft(16).or( new goog.math.Long(a, 0) ).getLowBitsUnsigned()
				}

				var adlerValue = adler32(filebuf);
				chunkadler32s.push(adlerValue+'');
			}

			currentChunk++;
			if (currentChunk < chunks) {
				loadNext();
			} else {
				var totalmd5 = sparktotal.end();
				callbackFn(file, totalmd5, chunkmd5s, chunkadler32s, chunkSize);
			}
		};
		fileReader.onerror = function () {
			console.warn('readFileMd5Adler32s error.');
			callbackFn(file, '', new Array(), new Array(), chunkSize);
		};
		function loadNext() {
			var start = currentChunk * chunkSize,
				end = ((start + chunkSize) >= fileobject.size) ? fileobject.size : start + chunkSize;
			fileReader.readAsArrayBuffer(blobSlice.call(fileobject, start, end));
		}
		setTimeout(loadNext, 100);
	}


	/*************************************** 定义对外函数 ******************************/
	kfsup.getstate = function(){
		return plup.state;
	},
	kfsup.stop = function(){
		plup.stop();
		plup.refresh();
	},
	kfsup.start = function(){
		plup.start();
		plup.refresh();
	},
	kfsup.destroy = function(){
		plup.destroy();
	},
	//根据文件ID获取文件对象 file[id/name/size/loaded/md5/chunkmd5s/chunkadler32s/chunksize]
	kfsup.getFile = function(fileid){
		return plup.getFile(fileid);
	}
	//获取所有文件ID列表，返回 fileid[], 按 order 排序
	kfsup.listFileIds = function(){
		var fileids = new Array();
		var files = plup.files;
		var maxorder = 0;
		for(var index in files){
			var file = files[index];
			if(maxorder<file.order)
				maxorder = file.order;
		}
		for(var order=0; order<=maxorder; order++){
			for(var index in files){
				var file = files[index];
				if(order==file.order){
					fileids.push(file.id);
					break;
				}
			}
		}
		return fileids;
	}
	//判断--当前是否正在进行文件上传操作
	kfsup.isUploading = function(){
		return kfsup.uploading.length>0;
	}
	//当前正在上传的文件ID
	kfsup.getUploadingFile = function(){
		return kfsup.uploading;
	}
	//判断--当前是否正在进行文件哈希计算操作
	kfsup.isHashing = function(){
		return kfsup.hashing.length>0;
	}
	//当前正在计算哈希的文件ID
	kfsup.getHashingFile = function(){
		return kfsup.hashing;
	}
	//移除文件
	kfsup.removeFile = function(fileid){
		var file = plup.getFile(fileid);
		if(file==null || typeof file=='undefined')
			return;
		if(kfsup.uploading==fileid){
			//正在上传中，我们先停止它
			kfsup.cancelFileUpload(file);
		}
		//移除
		plup.removeFile(file);
	}

	//发起动作--计算文件哈希
	kfsup.triggleFileHash = function(file, chunkSize){
		if(kfsup.hashing.length>0)
			//正在计算哈希，我们跳过该操作
			return;

		if(typeof(file.md5)!='undefined' && file.md5.length>0 && file.chunksize==chunkSize){
			//之前已经计算过了...
			if(kfsup.onFileHashed){
				//触发事件
				kfsup.onFileHashed(file, file.md5, file.chunkmd5s, file.chunkadler32s, file.chunksize);
			}
			return;
		}

		//发起后台任务：计算md5
		try{
			kfsup.hashing = file.id;
			readFileMd5Adler32s(file, chunkSize, chunkSize>0, chunkSize>0,
				function(file, filemd5, chunkMd5s, chunkAdler32s, chunkSize){
					//标记哈希计算完毕
					kfsup.hashing = '';

					//记录到文件对象:
					file.md5 = filemd5;
					file.chunkmd5s = chunkMd5s;
					file.chunkadler32s = chunkAdler32s;
					file.chunksize = chunkSize;

					if(kfsup.onFileHashed){
						//触发事件
						kfsup.onFileHashed(file, file.md5, file.chunkmd5s, file.chunkadler32s, file.chunksize);
					}
				}
			);
		}catch(e){
			console.log("计算md5失败");
			console.log(e);
			console.log(file);

			//标记哈希计算完毕
			kfsup.hashing = '';
			file.md5 = '';
			file.chunkmd5s = new Array();
			file.chunkadler32s = new Array();
			file.chunksize = chunkSize;
			if(kfsup.onFileHashed){
				kfsup.onFileHashed(file, '', file.chunkmd5s, file.chunkadler32s, file.chunksize);
			}
		}
	}
	//发起动作--上传文件（如果有其他文件正在执行上传，则我们忽略该请求）
	kfsup.triggleFileUpload = function(file, chunksize, maxretries){
		if(chunksize>0)
			plup.setOption("chunk_size", chunksize);
		else
			plup.setOption("chunk_size", 0);
		if(maxretries>0)
			plup.setOption("max_retries", maxretries);
		else
			plup.setOption("max_retries", 0);

		if( kfsup.uploading.length==0 ){
			kfsup.uploading = file.id;
			plup.startFileUpload(file);
		}else{
			//正在上传文件，我们跳过该操作
		}
	}
	//配置上传参数
	kfsup.setUploadParams = function(httpurl, httpmethod, httpheaders, ispostmultiform, postmultiforms){
		plup.setOption("url", httpurl);
		plup.setOption("http_method", httpmethod);
		if(httpheaders==undefined || httpheaders==null){
			plup.setOption("headers", {});
		}else{
			plup.setOption("headers", httpheaders);
		}
		plup.setOption("multipart", ispostmultiform);
		if(ispostmultiform){
			if(postmultiforms==undefined || postmultiforms==null){
				plup.setOption("multipart_params", {});
			}else{
				plup.setOption("multipart_params", postmultiforms);
			}
			plup.setOption("file_data_name", "file");
		}else{
			plup.setOption("multipart_params", {});
		}
		plup.setOption("send_file_name", false);		//setOption设置属性时, send_file_name 尽量放到最后一个去设置(设置其他属性时可能会附带修改该属性值)
	}
	//执行操作--设置为跳过分片传输
	kfsup.setChunkSkip = function(file, chunkOffset){
		if(file.chunkskip){
		}else{
			file.chunkskip = new Array();
		}
		file.chunkskip.push(chunkOffset);
	}
	//执行操作--取消传输文件
	kfsup.cancelFileUpload = function(file){
		kfsup.uploading = '';
		plup.stop();
		if(kfsup.onFileUploadCancel){
			kfsup.onFileUploadCancel(file);
		}
	}

	//事件函数--当有新文件加入后 onFileAdded(files)
	kfsup.bindFileAdded = function(onFileAdded){
		kfsup.onFileAdded = onFileAdded;
	}
	//事件函数--当文件md5计算完毕后触发 onFileHashed(file)
	kfsup.bindFileHashed = function(onFileHashed){
		kfsup.onFileHashed = onFileHashed;
	}
	//事件函数--当准备要上传该文件时触发 onFileUploadBegin(file)
	//该函数如果返回 true 则表示需要执行数据上传, 如果返回 false 则表示跳过数据上传
	kfsup.bindFileUploadBegin = function(onFileUploadBegin){
		kfsup.onFileUploadBegin = onFileUploadBegin;
	}
	//事件函数--当上传文件传输成功后触发 onFileUploadSuccess(file)
	kfsup.bindFileUploadSuccess = function(onFileUploadSuccess){
		kfsup.onFileUploadSuccess = onFileUploadSuccess;
	}
	//事件函数--当上传文件传输失败后触发 onFileUploadError(file)
	kfsup.bindFileUploadError = function(onFileUploadError){
		kfsup.onFileUploadError = onFileUploadError;
	}
	//事件函数--当上传文件传输被取消后触发 onFileUploadCancel(file)
	kfsup.bindFileUploadCancel = function(onFileUploadCancel){
		kfsup.onFileUploadCancel = onFileUploadCancel;
	}
	//事件函数--当上传文件分片传输开始后触发 onChunkUploadBegin(file, chunkOffset)
	//该函数如果返回 true 则表示需要执行数据上传, 如果返回 false 则表示跳过数据上传
	kfsup.bindChunkUploadBegin = function(onChunkUploadBegin){
		kfsup.onChunkUploadBegin = onChunkUploadBegin;
	}
	//事件函数--当上传文件分片传输成功后触发 onChunkUploadSuccess(file, chunkOffset)
	kfsup.bindChunkUploadSuccess = function(onChunkUploadSuccess){
		kfsup.onChunkUploadSuccess = onChunkUploadSuccess;
	}
	//事件函数--传输进度 onFileUploadProgress(file, loaded)
	kfsup.bindFileUploadProgress = function(onFileUploadProgress){
		kfsup.onFileUploadProgress = onFileUploadProgress;
	}
};
module.exports = kabalaupload;
